import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FileHistoryLogSchema = withDefaults({
  type: 'file-history-log',
  fields: [
    {
      kind: 'attribute',
      name: 'detail',
    },
    {
      kind: 'belongsTo',
      name: 'fileHistory',
      type: 'file-history',
      options: {
        async: false,
        inverse: 'fileHistoryLogs',
      },
    },
  ],
});

export default FileHistoryLogSchema;
